import React, { useEffect, useRef } from "react";
import Dialog from "../../../lib/Dialog";
import general from "../../../general";

export default function MobileVerify(props) {
  const { visiable, mobile, type } = props;

  const mobileRef = useRef(mobile);
  const typeRef = useRef(type);
  mobileRef.current = mobile;
  typeRef.current = type;

  const handler = (captchaObj) => {
    window.captchaObj = captchaObj;
    console.log("captchaObj", captchaObj);

    captchaObj
      .appendTo("#captcha")
      .onReady(function () {
        console.log("ready");
      })
      .onNextReady(function () {})
      .onBoxShow(function () {
        console.log("boxShow");
      })
      .onError(function (e) {
        console.log(e);
      })
      .onClose(() => {
        if (props.onClose) {
          props.onClose();
        }
      })
      .onSuccess(() => {
        if (captchaConfig.config.product === "bind") {
          validate();
        }
      });
  };

  const captchaConfig = {
    config: {
      captchaId: "2f2095eb51eb07c4091c71cb7d81a0ad",
      product: "bind",
    },
    handler: handler,
  };

  useEffect(() => {
    if (visiable) {
      overseasVerify();
    }
  }, [visiable]);

  const overseasVerify = () => {
    if (captchaConfig.config.product === "bind") {
      if (window.captchaObj) {
        window.captchaObj.showCaptcha();
      } else {
        Dialog.info("请等待验证初始化完成");
        return false;
      }
    } else {
      validate();
    }
  };

  const validate = () => {
    var result = window.captchaObj.getValidate();
    if (!result) {
      Dialog.info("请先完成验证！");
      return;
    }
    Dialog.loading();
    general.axios
      .post(
        "/verifyGraphicCaptcha",
        Object.assign(result, {
          mobile: mobileRef.current,
          type: typeRef.current,
          code: "code",
        }),
      )
      .finally(() => {
        Dialog.close();
      })
      .then((res) => {
        const { status } = res?.data;
        if (props.onClose) {
          props.onClose();
        }
        if (status.succeed) {
          if (props.onSuccess) {
            props.onSuccess();
          }
        } else {
          Dialog.error(status.error_desc);
        }
      });
  };

  useEffect(() => {
    if (window.initAlicom4) {
      window.initAlicom4(
        {
          captchaId: "2f2095eb51eb07c4091c71cb7d81a0ad",
          product: "bind",
        },
        handler,
      );
    }
  }, []);

  return <div className="captcha"></div>;
}
